import CheckoutOverlay from '../../../../../v2/components/CheckoutOverlay/CheckoutOverlay';
import SpotiiOverlayLazyLoader from './SpotiiOverlay/SpotiiOverlayLazyLoader';

export default function SpotiiOverlay() {
  return (
    <CheckoutOverlay
      popup
      stickyHeader
      nopadding
    >
      <SpotiiOverlayLazyLoader />
    </CheckoutOverlay>
  );
}
